import { useChipSetStore } from '../store/chipSetStore'

export class ChipSetService {
  selectNextChip() {
    const chipSetStore = useChipSetStore.getState()
    const currentIndex = chipSetStore.currentIndex
    if (chipSetStore.computed.hasNext) {
      useChipSetStore.setState({
        currentIndex: currentIndex + 1,
      })
    }
  }

  selectPreviousChip() {
    const chipSetStore = useChipSetStore.getState()
    const currentIndex = chipSetStore.currentIndex
    if (chipSetStore.computed.hasPrev) {
      useChipSetStore.setState({
        currentIndex: currentIndex - 1,
      })
    }
  }

  selectChipByStake(stake: number) {
    const chipSetStore = useChipSetStore.getState()
    const chipSet = chipSetStore.chipSet
    const index = chipSet.indexOf(stake)

    if (index === -1) {
      throw new Error(`Stake ${stake} not found in chip set`)
    }

    useChipSetStore.setState({
      currentIndex: index,
    })
  }

  forceOneStake(stake: number) {
    useChipSetStore.setState({
      chipSet: [stake],
      currentIndex: 0,
      tempIndex: 0,
    })
  }
}
